import { combineReducers } from 'redux';
import detail from './detail';

export default combineReducers({
    detail
});


// WEBPACK FOOTER //
// ./src/actions/researchCenter/index.js